import {getInteractiveLayers} from "../../utils/getInteractiveLayers";
import {IApplicationState} from "../../store/types";

export function mapStateToProps (state: IApplicationState) {
    return {
        // ...state,
        showLayerList: state.ui.showLayerList,
        showTable: state.ui.showTable,
        isEditing: state.ui.isEditing,
        editMode: state.ui.editMode,
        styleName: state.map.styleName,
        mapStyle: state.map.mapStyle,
        layers: state.map.layerIds,
        interactiveLayerIds: getInteractiveLayers(state.map.mapStyle),
        layerState: state.map.layerState,
        databaseLayerIds: state.map.databaseLayerIds,
        // viewport: state.viewport,
        // userType: state.userType
    };
}
